import React, { Component } from 'react';
import { connect } from 'react-redux';
import { processPayment } from './actions';
import { withNamespaces } from 'react-i18next';
import FontAwesome from 'react-fontawesome';

class Process extends Component {
	componentDidMount() {
		const { match, history, processPayment } = this.props;
		if (match.params.id) {
			const paymentId = Number(match.params.id);
			processPayment({ paymentId }, history);
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.httpBodyParams && !prevProps.httpBodyParams) {
			this.submitPaymentRedirectForm();
		}
	}

	// required by ePay and Clover Connect to redirect to their site
	renderPaymentRedirectForm() {
		const { requiresRedirection, redirectUrl, httpBodyParams } = this.props;
		if (requiresRedirection && httpBodyParams) {
			const jsonPostParams = JSON.parse(httpBodyParams);
			return <form action={redirectUrl} method='post' ref='paymentRedirectForm' >
				{Object.keys(jsonPostParams).map(key => <input type='hidden' name={key} value={jsonPostParams[key]} />)}
				<input type='submit' style={{ display: 'none' }} />
			</form>;
		}

		return null;
	}

	submitPaymentRedirectForm() {
		this.refs.paymentRedirectForm.submit();
	}

	render() {
		const { t } = this.props;

		return <div>
			<div style={{ textAlign: 'center', fontSize: '16px', color: '#0071ac' }}>
				<div>{t('FO_Booking_ProcessingPayment')}</div>
				<FontAwesome name='spinner' spin size='3x' />
			</div>
			{this.renderPaymentRedirectForm()}
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const { result } = state.booking;

	return {
		...result
	};
};

export default connect(mapStateToProps, {
	processPayment
})(withNamespaces()(Process));